import React, { useRef, useState } from "react";
import { Form } from "react-bootstrap";

function EditableRangeFormatable(props) {

	const input = useRef();
	const range = useRef();
	const [value, setValue] = useState(props.value);
	const [displayValue, setDisplayValue] = useState(props.outFormatter ? props.outFormatter(props.value) : props.value);

	function handleOnChange(v, update) {
		if(props.onChange)
			props.onChange(v);
		if(update){
			setValue(v);
			setDisplayValue(props.outFormatter(v))
		}
	}

	function handleOnMouseUp(val) {
		if(props.onMouseUp)
			props.onMouseUp(val);
	}

	function handleInput(e) {
		var original = e.target.value.replace(",", ".");
		var parsed = props.inFormatter ? props.inFormatter(original) : parseFloat(original);

		if(!isNaN(parsed)){
			e.target.value = original;
			handleOnChange(parsed, true);
			e.target.classList.remove("border-danger");
		}
		else {
			e.target.classList.add("border-danger");
		}
	}

	function handleKeyPress(e) {
		e.stopPropagation();

		var step = Number(props.step);
		var max  = Number(props.max);
		var min  = Number(props.min);

		var decimals = Number.isInteger(step) ? 0 : (step.toString().split(".")[1].length || 0);

		var next;
		switch(e.key){
			case 'ArrowDown':
				next = Number((Number(value) * 100 - step * 100) / 100).toFixed(decimals);
				next = next < min ? min : next;
				break;
			case 'ArrowUp':
				next = Number((Number(value) * 100 + step * 100) / 100).toFixed(decimals);
				next = next > max ? max : next;
				break;
			case 'Backspace':
				next = Math.floor(Number(value) / 10);
				break;
			default:
				if(/^\d$/.test(e.key)){
					next = Number(String(value) + e.key);
				} else {
					return;
				}
		}

		setDisplayValue(props.outFormatter(next));
		setValue(next);
		handleOnChange(next, false);
		e.target.classList.remove("border-danger");
	}

	return (
		<div className={"editableRange formatable " + props.wrpClassName}>
			<Form.Range
				name={props.name}
				ref={range}
				className={props.className}
				min={props.min}
				max={props.max}
				step={props.step}
				value={value}
				defaultValue={value}
				onMouseUp={(e) => handleOnMouseUp(e.target.value)}
				onChange={(e) => handleOnChange(e.target.value, true)}
			/>
			<input
				ref={input}
				onKeyDown={(e) => handleKeyPress(e)}
				className="manual form-control"
				type="text"
				value={displayValue}
				defaultValue={displayValue}
			/>
		</div>
	);
}

export default EditableRangeFormatable;
